








































































































import Vue from 'vue'

export default Vue.extend({
  name: 'DashboardDesign',
  data() {
    return {}
  },

  computed: {
    model() {
      return this.$store.state.server
    },
  },

  methods: {},
})
